<script setup lang="ts">
import TestataHome from '@/components/testate/TestataHome.vue'
import { useRouter, useRoute } from 'vue-router';
import {Model} from "@/app/Model";
import {onMounted, ref} from "vue";
import {Comms, type IEsito} from "@/app/Comms";
import type {KeyValoreStr} from "@/app/data/DataTypes";

const router = useRouter();
const route = useRoute();
let model: Model = Model.getReactiveInstance();
const idDocMaster = ref(route.query.idDocMaster)
if (!route.query.idDocMaster) {
  router.push('/');
} else {
  checkStart();
}
function checkStart(): void {
  if (!Model.pen_setupped) {
    setTimeout(() => checkStart(), 100)
  } else if (!Comms.listAllDone) {
    Comms.getInstance().listAll(() => {
      checkStart();
    });
  } else {
    startAnalisi();
  }
}

//analisi
function responseOK( esito: IEsito): void{
  if (esito.response && esito.response.data && esito.response.data.pgQuery && esito.response.data.pgQuery.list && esito.response.data.pgQuery.list.length > 0 && esito.response.data.pgQuery.list[0].result) {
    let objectToEvaluate: { tipologia: string, oggetto_di_giudizio: string, capo_imputazione_legge?: string[] } = esito.response.data.pgQuery.list[0].result;
    if (objectToEvaluate.capo_imputazione_legge) {
      let conPesi: Array<{ capo_imputazione_legge: string, peso: number }> = [];
      objectToEvaluate.capo_imputazione_legge.forEach((capo: string): void => {
        let objPesi: { capo_imputazione_legge: string, peso: number } = {capo_imputazione_legge: capo, peso: 0};
        let objFind: KeyValoreStr | undefined = model.lista_capo_imputazione_legge.find((x: KeyValoreStr): boolean => {
          return x.capo_imputazione_legge === capo;
        });
        if (objFind && objFind.tot) {
          objPesi.peso = Number(objFind.tot);
        }
        conPesi.push(objPesi);
      })
      conPesi = conPesi.sort((a, b) => b.peso - a.peso);
      model.temp_capo_imputazione_legge = "";
      if (conPesi.length > 0 && conPesi[0].capo_imputazione_legge) {
        model.temp_capo_imputazione_legge = conPesi[0].capo_imputazione_legge;
      }
      router.push("/penale/dashboard");
    } else if (objectToEvaluate.oggetto_di_giudizio) {
      model.temp_oggetto_di_giudizio = objectToEvaluate.oggetto_di_giudizio;
      router.push("/famiglia/dashboard");
    }
  } else {
    router.push('/');
  }
}
function startAnalisi(): void {
  //entry
  Comms.getInstance().getAnalisiViewData(Number(route.query.idDocMaster), responseOK)
}
</script>

<template>
  <TestataHome></TestataHome>
  <main>
    <div class="container mt-5">
      <h3>Prego attendere...</h3>
      <div>Analizzo il documento: {{ idDocMaster }}</div>
      <div><br><br></div>
    </div>

  </main>
</template>